/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 
// var modal = document.querySelector(".modal");
// var trigger = document.querySelector(".trigger");
// var closeButton = document.querySelector(".close-button");

// function toggleModal() {
//     modal.classList.toggle("show-modal");
// }

// function windowOnClick(event) {
//     if (event.target === modal) {
//         toggleModal();
//     }
// }

// trigger.addEventListener("click", toggleModal);
// closeButton.addEventListener("click", toggleModal);
// window.addEventListener("click", windowOnClick);

 



// $(function() {

//   $('.contact-form').on( "submit", function(e) {
//     e.preventDefault();
//     e.stopPropagation();

//     var dataString = $(this).serialize();

//     $.ajax({
//       type: 'POST',     
//       url: '/contact',
//       data: dataString,     
//       error: function(t) {
//         console.log(t);

//       },
//       success: function(response) {

//         //console.log(response);
//         // alert('hiiii');
//         $('.alert--success').show();
//         $('.alert--error').hide();
//       }
//     });               

//   });

// });

//$(document).ready(function(){
  
  
  

  
//   $('.ex_vat').click(function(){
//     $('.ex_price').show();
//      $('.inc_vat.active').removeClass('active');
//     $(this).addClass('active');
   
//     $('.inc_price').hide();
//   });
  
//});


$(document).ready(function () {
  setTimeout(function () {
    console.log("Tm");
     $('.money-template').after('<button style="display:none" class="trigger prdt_quot_a">Quotation For Larger Quantities</button>');
     $('.money-template').css('padding', '1em 0');
  }, 1000);  
});

$('#get_qty').on('input', function () {
  if ($(this).val() > 499) {
    $('.prdt_quot_a').show(); 
    $('.product-form__add-button').hide(); 
    
  } else {
    $('.prdt_quot_a').hide(); 
      $('.product-form__add-button').show(); 
  }
});
$('body').on('click', '.prdt_quot_a', function(e) {
  e.preventDefault();
  $('#element_to_pop_up').bPopup();
});
 

$(document).ready(function(){
  setTimeout(function() {
  
var oldstring = $('.shappify_qb_grid tbody > tr:last-of-type > td:first-of-type').text().split("-")[1];
      
    //alert(oldstring);


      $('.shappify_qb_grid tbody > tr:last-of-type > td:first-of-type').text(oldstring);
    
  }, 2500);
  
  function dynamicPrice() {
    var Qty = $('#get_qty').val();
    var ar1new = $( ".shappify_qb_grid tbody tr" ).find("td").eq(0).text().split("-")[0];
    var ar1price = '£'+$( ".shappify_qb_grid tbody tr" ).find("td").eq(1).html().replace(/[^\d.-]/g, '');

    var qtyprice = $('.gethiddenprice').val();


   
	var static = false;
    $( ".shappify_qb_grid tbody tr" ).each( function( index, element ){

      
 	  
      var nthval = $(this).text();



      var val1 = $(this).find("td").eq(0).html();  
      var val2 = $(this).find("td").eq(1).html(); 
      
      //console.log(val1);

      var convertval2 = '£'+val2.replace(/[^\d.-]/g, '');
      //console.log(val2.replace(/[^\d.-]/g, ''));
      var myArray1 = val1.split("-");
      var pqty = parseInt(Qty);

      var ar1 =  parseInt(myArray1[0]);
      var ar2 =  parseInt(myArray1[1]);
      
      //console.log('ar1 value:'+ ar1);
      //console.log(myArray1[1].replace(/[0-9]/g, ''));
     // console.log(ar2);

//console.log('ar2 value:'+ (myArray1[0]).toString().trim());
      if ((myArray1[0].replace(/[0-9]/g, '')).toString().trim() === ("+")) {
        //console.log(ar1);
        ar1new=ar1;
        ar1price=convertval2;
         //console.log(myArray1[1]);
        if(pqty >= ar1) {
          qtyprice=convertval2;
          ar1new=ar1;
          ar1price=convertval2;
        }
      } else {
        
        if (static == "true") {
          //console.log('hiii');
          ar1new=ar1;
          ar1price=convertval2;
          return false;
        }
        
        if(pqty >= ar1 && pqty <= ar2){
          static = "true";
//           console.log(ar1);
//           console.log(ar2);
          
          qtyprice=convertval2;
          ar1new=ar1;
          ar1price=convertval2;
        }
      }
    });

    //console.log(qtyprice);

    $('.money').text(qtyprice);

    // console.log(ar1new);
    $('#appikon-notification-bar').text('Buy '+ ar1new +' to get item for ' +ar1price+' per metre');


  }
  
  
  function taxPrice() {
    
    
   
    
   
    
    var qtypriceval = $('.ex_price .money').text();
    
    qtypriceval = qtypriceval.replace("£","");


    var percentage = parseFloat((qtypriceval * 20)/100);

    console.log(percentage);
    
    var outval1 = parseFloat(qtypriceval);
    var outval2 = parseFloat(percentage);
    
    var additionval = (outval1 + outval2);

    
    
    var addfloat = additionval.toFixed(2);
     $('.inc_price').text("£"+addfloat);
    
  }
  
  setTimeout(function () {$('.shappify_qb_grid thead th:nth-child(2)').html('Price (Excluding VAT)')}, 10000);   

  $('body').on('click', '.quantity-selector__button', function(e) {

    dynamicPrice();
    taxPrice();

  });

  $('#get_qty').keyup(function(e) {

    dynamicPrice();
    taxPrice();

  });
  
  
  
  var unit = $('.pdt_unit').text().trim();
  //console.log(unit);

  setTimeout(function() {
    $( ".shappify_qb_grid tbody tr" ).each( function( index, element ){
      var val2 = $(this).find("td").eq(1).html(); 
      if(unit){
      $(this).find("td").eq(1).append(' per '+unit);
      }

      //console.log(val2+unit)



      
    });
  }, 2500);

});

 */

//TM 
$(document).ready(function () {
  setTimeout(function () {
    console.log("Tm");
     $('.money-template').after('<button style="display:none" class="trigger prdt_quot_a">Quotation For Larger Quantities</button>');
     $('.money-template').css('padding', '1em 0');
  }, 1000);  
});

$('#get_qty').on('input', function () {
  if ($(this).val() > 499) {
    $('.prdt_quot_a').show(); 
    $('.product-form__add-button').hide(); 
    
  } else {
    $('.prdt_quot_a').hide(); 
      $('.product-form__add-button').show(); 
  }
});
$('body').on('click', '.prdt_quot_a', function(e) {
  e.preventDefault();
  $('#element_to_pop_up').bPopup();
});
 

$(document).ready(function(){
  setTimeout(function() {  
    var oldstring = $('.shappify_qb_grid tbody > tr:last-of-type > td:first-of-type').text().split("-")[1];
    $('.shappify_qb_grid tbody > tr:last-of-type > td:first-of-type').text(oldstring);  
  }, 2500);  
  
  function dynamicPrice() {
    const Qty = parseInt($('#get_qty').val());
    let ar1new, ar1price, qtyprice = $('.gethiddenprice').val();
    let static = false;
    $(".shappify_qb_grid tbody tr").each(function () {
      const val1 = $(this).find("td").eq(0).html();
      const val2 = '£' + $(this).find("td").eq(1).html().replace(/[^\d.-]/g, '');
      const [ar1, ar2] = val1.split("-").map(v => parseInt(v));
      const isPlusRange = val1.trim().endsWith("+");
      if (isPlusRange) {
        if (Qty >= ar1) {
          ar1new = ar1;
          ar1price = val2;
          qtyprice = val2;
        }
      } else {
        if (static) return false;
        if (Qty >= ar1 && Qty <= ar2) {
          static = true;
          ar1new = ar1;
          ar1price = val2;
          qtyprice = val2;
        }
      }
    });
    $('.money').text(qtyprice);
    $('#appikon-notification-bar').text(`Buy ${ar1new} to get item for ${ar1price} per metre`);
  }
  
  function taxPrice() {
    const qtypriceval = parseFloat($('.ex_price .money').text().replace("£", ""));
    const additionval = (qtypriceval * 1.2).toFixed(2);
    $('.inc_price').text("£" + additionval);
  }

  setTimeout(function () {$('.shappify_qb_grid thead th:nth-child(2)').html('Price (Excluding VAT)')}, 10000);   
  
  $('body').on('click', '.quantity-selector__button', function(e) {
    dynamicPrice();
    taxPrice();
  });
  
  $('#get_qty').keyup(function(e) {
    dynamicPrice();
    taxPrice();
  });
  
  var unit = $('.pdt_unit').text().trim();
  setTimeout(function() {
    $( ".shappify_qb_grid tbody tr" ).each( function( index, element ){
      var val2 = $(this).find("td").eq(1).html(); 
      if(unit){
        $(this).find("td").eq(1).append(' per '+unit);
      }
    });
  }, 2500);
});

 